export const cloudradialFormFields = {
  PORTAL_URL: {
    id: 'portalUrl',
    label: 'Portal URL',
    placeholder: 'Your portal URL e.g “https://acme.cloudradial.com”'
  }
};
